// @flow
import React, { Component, Fragment } from 'react';
import type { EmailInfoData } from 'store/modules/settings';
import { MdWarning } from 'react-icons/md';
import Toggler from 'components/common/Toggler';
import cx from 'classnames';
import './SettingEmail.scss';

type Props = {
  emailInfo: EmailInfoData,
  onSaveEmailPermissions: () => Promise<any>,
  onChangeEmail: (email: string) => Promise<any>,
  onResendCertmail: () => Promise<any>,
  onUpdateEmailPermission: (payload: { name: string, value: boolean }) => void,
};

type State = {
  edit: boolean,
  email: string,
  status: 'idle' | 'success' | 'error',
};

class SettingEmail extends Component<Props, State> {
  state = {
    edit: false,
    email: '',
    status: 'idle',
  };

  onStartEditing = () => {
    this.setState({
      edit: true,
    });
  };

  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      email: e.target.value,
    });
  };

  onConfirm = async () => {
    const { email } = this.state;
    try {
      await this.props.onChangeEmail(email);
      this.setState({
        status: 'success',
      });
    } catch (e) {
      this.setState({
        status: 'error',
      });
      // handle error
      console.log(e);
    }
    this.setState({
      edit: false,
    });
  };

  onCancel = () => {
    this.setState({
      edit: false,
      email: '',
    });
  };

  onChangeToggler = (event: { name: string, value: boolean }) => {
    this.props.onUpdateEmailPermission(event);
  };

  render() {
    const { emailInfo, onSaveEmailPermissions } = this.props;
    const { edit, email } = this.state;
    return (
      <div className="SettingEmail">
        <div className="email-card">
          {edit ? (
            <div className="edit-section">
              <div className="section-header">
                <h3>이메일 변경</h3>
                <p>새로운 이메일 주소를 입력해주세요</p>
              </div>

              <div className="email-form">
                <label className="form-label" htmlFor="email-input">
                  새 이메일 주소
                  <input
                    id="email-input"
                    className="form-input"
                    type="email"
                    value={email}
                    onChange={this.onChange}
                    placeholder="새로운 이메일 주소를 입력하세요"
                  />
                </label>
              </div>

              <div className="warning-section">
                <div className="warning-icon">
                  <span role="img" aria-label="경고">
                    ⚠️
                  </span>
                </div>
                <div className="warning-text">
                  <strong>주의사항</strong>
                  <p>이메일 변경 시 이전 이메일로 다시 로그인할 수 없습니다.</p>
                </div>
              </div>

              <div className="form-actions">
                <button className="cancel-button" onClick={this.onCancel}>
                  취소
                </button>
                <button className="confirm-button" onClick={this.onConfirm}>
                  변경 완료
                </button>
              </div>
            </div>
          ) : (
            <Fragment>
              {!emailInfo.is_certified && emailInfo.email && (
                <div className="certification-alert">
                  <div className="alert-content">
                    <div className="alert-icon">
                      <span role="img" aria-label="메일">
                        📧
                      </span>
                    </div>
                    <div className="alert-text">
                      <strong>
                        {this.state.status === 'success'
                          ? '인증 메일이 발송되었습니다!'
                          : '이메일 인증이 필요합니다'}
                      </strong>
                      <p>
                        {this.state.status === 'success'
                          ? '메일을 확인하여 인증을 완료해주세요.'
                          : '등록된 이메일이 아직 인증되지 않았습니다.'}
                      </p>
                    </div>
                  </div>
                  <button className="resend-button" onClick={this.props.onResendCertmail}>
                    인증 메일 재발송
                  </button>
                </div>
              )}

              <div className="current-email-section">
                <div className="section-header">
                  <h3>현재 이메일</h3>
                  <p>등록된 이메일 주소를 확인하고 관리하세요</p>
                </div>

                <div className={cx('email-display', { empty: !emailInfo.email })}>
                  {!emailInfo.email && (
                    <div className="warning-icon">
                      <MdWarning />
                    </div>
                  )}
                  <div className="email-info">
                    <span className="email-text">
                      {emailInfo.email || '이메일이 등록되지 않았습니다'}
                    </span>
                    {emailInfo.is_certified && <span className="certified-badge">인증 완료</span>}
                  </div>
                  <button className="action-button" onClick={this.onStartEditing}>
                    {emailInfo.email ? '변경' : '등록'}
                  </button>
                </div>
              </div>
            </Fragment>
          )}
        </div>

        {!edit && emailInfo.is_certified && (
          <div className="notification-card">
            <div className="section-header">
              <h3>이메일 수신 설정</h3>
              <p>알림 및 프로모션 메일 수신 여부를 설정하세요</p>
            </div>

            <div className="togglers-section">
              <div className="toggler-item">
                <Toggler
                  name="email_notification"
                  text="댓글 알림"
                  value={emailInfo.permissions.email_notification}
                  onChange={this.onChangeToggler}
                />
                <p className="toggler-description">새로운 댓글이 달렸을 때 알림을 받습니다</p>
              </div>

              <div className="toggler-item">
                <Toggler
                  name="email_promotion"
                  text="이벤트 및 프로모션"
                  value={emailInfo.permissions.email_promotion}
                  onChange={this.onChangeToggler}
                />
                <p className="toggler-description">이벤트, 할인, 신상품 등의 정보를 받습니다</p>
              </div>
            </div>

            <div className="form-actions">
              <button className="save-button" onClick={onSaveEmailPermissions}>
                설정 저장
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SettingEmail;



// WEBPACK FOOTER //
// ./src/components/settings/SettingEmail/SettingEmail.js